import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { ListingDescription } from "./ListingDescription"

export interface GenerateListingDescriptionPathParams {
	inventoryId: string
}

export const generateListingDescriptionRoute: ApiRoute<
	GenerateListingDescriptionPathParams,
	NoQueryParams,
	NoBody,
	ListingDescription
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/generate-description`,
	method: "get",
	path: "/vehicles/:inventoryId/generate-description",
}
